module.exports = __webpack_public_path__ + "img/22.1e4c78e6.png";